import React, { PureComponent } from "react";

class CalendarCell extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { startTime, stopTime, value, withinRange } = this.props;

    const onMouseDown = e => this.props.onMouseDown(e, startTime, value);
    const onMouseMove = e => this.props.onMouseMove(e, stopTime);
    const onClick = () => {
      this.props.onClick(startTime, stopTime, value);
    };

    return (
      <div
        id="calendarCell"
        className={`calendar-cell ${withinRange ? "in-range" : ""}`}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={this.props.onMouseUp}
        onClick={onClick}
      >
        {value !== undefined ? `${value}€` : ""}
      </div>
    );
  }
}

export default CalendarCell;
